// eslint-disable-next-line import/prefer-default-export
export const GMAPS_API_KEY = 'AIzaSyDj93quiCb6H5gKRZMkZK7SBkCgbWxqo94';
